import { Component, EventEmitter, HostListener, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Block } from '../../../models/block.model';
import { CustomerPage } from '../../../models/customerPage.model';
import { RoleType } from '../../enums/role-type/role-type.module';
import { CustomerPageData } from '../../../models/customerPageData.model';
import { OfferStatus } from '../../enums/offer-status/offer-status.module';
import { RefBusinessLists } from '../../../models/refBusinessLists.model';
import { ConnectionDefinition } from '../../../models/connectionDefinition.model';
import { AppStateService } from '../../../services/shared/app-state/app-state.service';
import { CustomerService } from '../../../services/customer/customer.service';
import { CompletionStatus } from '../../enums/completion-status/completion-status.module';
import { TranslationService } from '../../../services/translation/translation.service';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { Subject, takeUntil } from 'rxjs';
import { LoadingService } from '../../../services/loading/loading.service';
import { Customer } from '../../../models/customer.model';

@Component({
  selector: 'app-summary-modal',
  templateUrl: './summary-modal.component.html',
  styleUrl: './summary-modal.component.css'
})
export class SummaryModalComponent implements OnInit, OnDestroy {

  customerId: string;
  summaryBlocks: Block[];
  customerPage: CustomerPage;
  userRole: RoleType;
  customerPageDatas: CustomerPageData[];
  isPreview: boolean;
  offerStatus: OfferStatus;
  offerHidden: boolean;
  isAllRequiredFilled: boolean;
  blockHasErrors: boolean;
  isMobile = window.innerWidth <= 1023;
  refBusinessLists: RefBusinessLists;
  fullConnectionsDefinitions: ConnectionDefinition[];
  isEmbed: boolean = false;
  RoleType = RoleType;

  @Output() fieldContainerClick = new EventEmitter<HTMLElement>();
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<SummaryModalComponent>,
    private appState: AppStateService,
    private customerService: CustomerService,
    private translationService: TranslationService,
    private snackBar: SnackbarService,
    private loadingService: LoadingService,
    @Inject(MAT_DIALOG_DATA) public data: {
      customerId: string,
      summaryBlocks: Block[],
      customerPage: CustomerPage,
      userRole: RoleType,
      customerPageDatas: CustomerPageData[],
      isPreview: boolean,
      offerStatus: OfferStatus,
      offerHidden: boolean,
      isAllRequiredFilled: boolean,
      blockHasErrors: boolean,
      refBusinessLists: RefBusinessLists,
      fullConnectionsDefinitions: ConnectionDefinition[]
    }
  ) {
    this.customerId = data.customerId;
    this.summaryBlocks = data.summaryBlocks;
    this.customerPage = data.customerPage;
    this.userRole = data.userRole;
    this.customerPageDatas = data.customerPageDatas;
    this.isPreview = data.isPreview;
    this.offerStatus = data.offerStatus;
    this.offerHidden = data.offerHidden;
    this.isAllRequiredFilled = data.isAllRequiredFilled;
    this.blockHasErrors = data.blockHasErrors;
    this.refBusinessLists = data.refBusinessLists;
    this.fullConnectionsDefinitions = data.fullConnectionsDefinitions;
  }

  ngOnInit() {
    this.isEmbed = this.appState.getIsEmbed();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onConfirm(): void {
    if (this.isPreview)
    {
      this.dialogRef.close(true);
    }
    else
    {
      this.loadingService.show();
      this.dialogRef.disableClose = true;
      this.customerService.updateCustomerPageStatus(this.customerId!, this.customerPage.id!, CompletionStatus.COMPLETED)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.dialogRef.disableClose = false;
            this.dialogRef.close(true);
            this.loadingService.hide();
          },
          error: (error) => {
            this.dialogRef.disableClose = false;
            this.loadingService.hide();
            this.snackBar.showError(this.translationService.translate('Error on updating page status'));

            if(!this.offerHidden){
              this.dialogRef.close(true);
            }
          }
        });
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onFieldContainerClick(element: HTMLElement) {
    this.dialogRef.close(element);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    this.isMobile = window.innerWidth <= 1023;
  }
}
